var map = {
	"./bedok-back.png": 48,
	"./edb-back.png": 49,
	"./hdb-back.png": 50,
	"./limchukang-back.png": 51,
	"./mandai-back.png": 52,
	"./mindef-back.png": 53,
	"./museum-back.png": 54,
	"./npb-back.png": 55,
	"./pasirris-back.png": 56,
	"./punggol-back.png": 57,
	"./seletar-back.png": 58,
	"./sembawang-back.png": 59,
	"./stb-back.png": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;